export type ReputationRangeDays = 7 | 30 | 90;

export const REPUTATION_RANGE_DAYS: ReputationRangeDays[] = [7, 30, 90];

/** ISO window start (local midnight, `days` back) — stable within a day for query keys. */
export function reputationWindowFrom(days: ReputationRangeDays): string {
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - days);
  return start.toISOString();
}
